import moment from "moment";
import QRCode from 'qrcode'

const utils = {
    //
    windowScrollTouchend({ threshold = 1, touchend }) {
        const handleScroll = () => {
            const { scrollTop, scrollHeight } = document.documentElement;
            const height = window.innerHeight;

            if (scrollTop + height >= scrollHeight - threshold) {
                if (touchend) touchend();
            }
        }
        window.addEventListener('scroll', handleScroll);
    },
    dateFormat(date, format) {
        //$moment(new Date(item.eventTime.start)).format()
        if(date){
            return moment(date).format(format);
        }
        return '';        
    },
    async generateQRCode(inputText) {
        if (!inputText.trim()) {
            throw new Error('請輸入文本');
        }

        try {
           
            return await QRCode.toDataURL(inputText, {
                width: 200,       
                margin: 2,        
                color: {
                    dark: '#000000',   
                    light: '#ffffff'   
                }
            })
        } catch (error) {
            throw error;
        }
    },
}

export default utils